import React from 'react';
import { Edit, Plus, Building, ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const EtablissementHeader = ({ etablissement, onEditClick }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-r from-[#202654] to-[#2a2f6a] rounded-xl shadow-lg mb-8">
      <div className="p-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
          <div className="flex items-center mb-4 md:mb-0">
            <button
              onClick={() => navigate(-1)}
              className="mr-4 p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-all duration-200 backdrop-blur-sm"
            >
              <ChevronLeft className="h-5 w-5 text-white" />
            </button>
            <div className="bg-white/20 p-3 rounded-lg mr-4">
              <Building className="h-8 w-8 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-white mb-2">
                Informations de l'établissement
              </h1>
              <p className="text-blue-100 text-lg">
                Gérez les informations de base de votre institution
              </p>
            </div>
          </div>
          
          <div className="flex space-x-3">
            {etablissement ? (
              <button
                onClick={onEditClick}
                className="bg-white/20 hover:bg-white/30 text-white px-6 py-3 rounded-lg font-medium transition-all duration-200 flex items-center backdrop-blur-sm border border-white/30 hover:border-white/50"
              >
                <Edit className="h-5 w-5 mr-2" />
                Modifier
              </button>
            ) : (
              <button
                onClick={onEditClick}
                className="bg-white hover:bg-gray-50 text-[#202654] px-6 py-3 rounded-lg font-medium transition-all duration-200 flex items-center shadow-lg hover:shadow-xl"
              >
                <Plus className="h-5 w-5 mr-2" />
                Ajouter
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EtablissementHeader; 